import type { ApiClient } from '../client';
import type {
  ApiResponse,
  StaffAttendanceQuickEntryRequest,
  StaffAttendanceQuickEntryResponse,
  StaffAttendanceSheetQuery,
  StaffAttendanceSheetResponse,
} from '../types';

export function bindStaffAttendance(client: ApiClient) {
  return {
    async getStaffAttendanceSheet(
      params: StaffAttendanceSheetQuery
    ): Promise<ApiResponse<StaffAttendanceSheetResponse>> {
      const qs = new URLSearchParams();
      qs.set('date', params.date);
      if (params.role?.trim()) qs.set('role', params.role.trim());
      if (params.department_id?.trim()) qs.set('department_id', params.department_id.trim());
      if (params.search?.trim()) qs.set('search', params.search.trim());
      if (params.page) qs.set('page', String(params.page));
      if (params.limit) qs.set('limit', String(params.limit));
      return client.request<StaffAttendanceSheetResponse>(
        `/attendance/staff/sheet?${qs.toString()}`
      );
    },

    async staffAttendanceQuickEntry(
      body: StaffAttendanceQuickEntryRequest
    ): Promise<ApiResponse<StaffAttendanceQuickEntryResponse>> {
      return client.request<StaffAttendanceQuickEntryResponse>('/attendance/staff/quick-entry', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },
  };
}
